/**
 * The ID3Info class contains properties that reflect ID3 metadata. You can get additional
 * metadata for MP3 files by accessing the <codeph class="+ topic/ph pr-d/codeph ">id3</codeph>
 * property of the Sound class; for example, <codeph class="+ topic/ph pr-d/codeph ">mySound.id3.TIME</codeph>.
 * For more information, see the entry for <codeph class="+ topic/ph pr-d/codeph ">Sound.id3</codeph> and
 * the ID3 tag definitions at <xref href="http://www.id3.org" class="- topic/xref ">http://www.id3.org</xref>.
 */
var ID3Info = (function () {
    function ID3Info() {
    }
    return ID3Info;
}());
export { ID3Info };
